import { settings } from "../kernel/Settings";
export class CDNPathUtil {
    static getFilePath(filename) {
        return `${settings.S3CDN}${settings.viewAssetsPath}${filename}`;
    }
    static getAssetsPath(path) {
        return `${settings.S3CDN}${settings.assets}${path}`;
    }
    static getIconAssetUrl(filename) {
        return CDNPathUtil.getAssetsPath(`/icons/${filename}`);
    }
    static getImageAssetUrl(filename) {
        return CDNPathUtil.getAssetsPath(`/images/${filename}`);
    }
}
